import { FC, useState } from "react";
import { YhBox } from "@/components/YhBox";
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";
import useNavModel, { RouterParamType } from "@/model/navModel";
import { useVrmMaintenanceDetailsModel } from "../vrmBillMaintenanceRoModel";
import { Description } from "@/components/YhBox/Description";
import { useGlobalModel } from "@/model/globalModel";
import { Button } from 'antd';

export const TopButs: FC<RouterParamType> = ({ id, mode }) => {
    const { detailLookForm, } = useVrmMaintenanceDetailsModel();
    const { getCiDictByDictCode } = useGlobalModel(() => []);
    const { selectedNavId, replaceNav, getSelectedNavState } = useNavModel();
    const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType);
    const goBack = () => {
        if (detailsInfo.parentInfo && detailsInfo.parentInfo.selectedNavId) {
            replaceNav(selectedNavId, detailsInfo.parentInfo.selectedNavId);
        }
    }
    const action = <>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={goBack}
        >返回</Button>
    </>
    const orderStatu: IDescription[] = [
        {
            label: "维修退单",
            value: detailLookForm.returnCode ?? "暂无",
            color: DescriptionColorEnum.blue,
            status: true
        },
        {
            label: "状态",
            value: detailLookForm.returnStatus == 'billed' ? '已开单' : detailLookForm.returnStatus == 'in_stock' ? '已入库' : detailLookForm.returnStatus == 'settled' ? '已结算' : '',
            color: DescriptionColorEnum.green,
            status: true
        }
    ]

    return (
        <YhBox title={<>
            {orderStatu.map((item, index) => <Description key={index} {...item} />)}
        </>}
            action={action}
            style={{ paddingBottom: 0, marginBottom: "15px" }}
        />
    )
}